import moment from 'moment'

const toThaiDatetime = (date, format = 'D MMMM Y') => {
  const m = moment(date)

  if (!m.isValid()) return null

  const thaiYear = m.year() + 543

  format = format.replace(/Y+/g, thaiYear)

  return m.format(format)
}

const age = date => {
  return date ? moment().diff(date, 'years') : ''
}

export default {
  filters: {
    $_datetime_thaiDatetime(value, format) {
      return toThaiDatetime(value, format)
    },

    $_datetime_age(value) {
      return age(value)
    }
  },

  methods: {
    $_datetime_toThaiDatetime(date, format) {
      return toThaiDatetime(date, format)
    },

    $_datetime_toAge(date) {
      return age(date)
    }
  }
}
